import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer">

      <Container>

        {/* =====================================================
            MAIN FOOTER
        ====================================================== */}

        <Row className="footer-main">

          {/* ===================================================
              BRAND
          ==================================================== */}

          <Col lg={4} md={12} className="footer-brand-section">

            <Link
              to="/"
              className="footer-brand"
              aria-label="DFluxSpace Home"
            >

              <span className="footer-logo-wrap">

                <img
                  src="/dfluxspace.png"
                  alt="DFluxSpace"
                  className="footer-logo"
                  width="42"
                  height="42"
                />

              </span>

              <span className="footer-brand-text">
                DFLUX<span>SPACE</span>
              </span>

            </Link>


            <p className="footer-description">
              Explore technology, artificial intelligence, science, space,
              finance, business and the future through informative articles,
              insights and discoveries.
            </p>


            {/* =================================================
                SOCIAL LINKS
            ================================================== */}

            <div
              className="footer-social"
              aria-label="DFluxSpace social media"
            >

              <a
                href="https://whatsapp.com/channel/0029Vb5mAijCxoB44d0EpQ2a"
                className="footer-social-link"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="DFluxSpace WhatsApp Channel"
              >
                <i className="fab fa-whatsapp"></i>
              </a>


              <a
                href="https://www.facebook.com/share/163tuiKK3R/"
                className="footer-social-link"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="DFluxSpace Facebook"
              >
                <i className="fab fa-facebook-f"></i>
              </a>


              <a
                href="https://www.youtube.com/@FutureWay-RX800"
                className="footer-social-link"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Future Way YouTube Channel"
              >
                <i className="fab fa-youtube"></i>
              </a>


              <a
                href="https://www.instagram.com/dinesh_futureway?igsh=bzAzZ3p3OTY2ZzNu"
                className="footer-social-link"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="DFluxSpace Instagram"
              >
                <i className="fab fa-instagram"></i>
              </a>


              <a
                href="https://x.com/dfluxspace?t=In-P5YV6fLI2ozdqmO_a6w&s=08"
                className="footer-social-link"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="DFluxSpace on X"
              >
                <i className="fab fa-x-twitter"></i>
              </a>


              <Link
                to="/blogs"
                className="footer-social-link"
                aria-label="DFluxSpace Blogs"
              >
                <i className="fas fa-blog"></i>
              </Link>

            </div>

          </Col>


          {/* ===================================================
              EXPLORE
          ==================================================== */}

          <Col lg={3} md={4} sm={6} className="footer-column">

            <h2 className="footer-heading">
              Explore
            </h2>

            <nav aria-label="Explore DFluxSpace">

              <ul className="footer-links">

                <li>
                  <Link to="/technology">Technology</Link>
                </li>

                <li>
                  <Link to="/ai">Artificial Intelligence</Link>
                </li>

                <li>
                  <Link to="/science">Science</Link>
                </li>

                <li>
                  <Link to="/space">Space</Link>
                </li>

                <li>
                  <Link to="/finance">Finance</Link>
                </li>

                <li>
                  <Link to="/business">Business</Link>
                </li>

                <li>
                  <Link to="/health">Health</Link>
                </li>

                <li>
                  <Link to="/education">Education</Link>
                </li>

              </ul>

            </nav>

          </Col>


          {/* ===================================================
              DISCOVER
          ==================================================== */}

          <Col lg={2.5} md={4} sm={6} className="footer-column">

            <h2 className="footer-heading">
              Discover
            </h2>

            <nav aria-label="Discover DFluxSpace">

              <ul className="footer-links">

                <li>
                  <Link to="/orgblogList">
                    Trending Blogs
                  </Link>
                </li>

                <li>
                  <Link to="/blogs">
                    All Blogs
                  </Link>
                </li>

                <li>
                  <Link to="/shorts">
                    Shorts
                  </Link>
                </li>

                <li>
                  <Link to="/products">
                    Products
                  </Link>
                </li>

                <li>
                  <Link to="/about">
                    About DFluxSpace
                  </Link>
                </li>

                <li>
                  <Link to="/contact">
                    Contact
                  </Link>
                </li>

                <li>
                  <Link to="/faq">
                    FAQ
                  </Link>
                </li>

              </ul>

            </nav>

          </Col>


          {/* ===================================================
              LEGAL
          ==================================================== */}

          <Col lg={2.5} md={4} sm={12} className="footer-column">

            <h2 className="footer-heading">
              Legal
            </h2>

            <nav aria-label="DFluxSpace legal information">

              <ul className="footer-links">

                <li>
                  <Link to="/privacy-policy">
                    Privacy Policy
                  </Link>
                </li>

                <li>
                  <Link to="/terms">
                    Terms &amp; Conditions
                  </Link>
                </li>

                <li>
                  <Link to="/dmca">
                    DMCA
                  </Link>
                </li>

              </ul>

            </nav>

          </Col>

        </Row>


        {/* =====================================================
            FOOTER SEO / SITE INFORMATION
        ====================================================== */}

        <div className="footer-seo">

          <p>
            DFluxSpace publishes independent articles and insights covering
            technology, AI, science, space, finance, business and emerging
            innovations.
          </p>

        </div>


        {/* =====================================================
            BOTTOM BAR
        ====================================================== */}

        <div className="footer-bottom">

          <div className="footer-copyright">

            © {currentYear}{" "}
            <strong>DFluxSpace</strong>.
            All rights reserved.

          </div>


          <div className="footer-bottom-links">

            <Link to="/privacy-policy">
              Privacy
            </Link>

            <span>•</span>

            <Link to="/terms">
              Terms
            </Link>

            <span>•</span>

            <Link to="/dmca">
              DMCA
            </Link>

          </div>

        </div>

      </Container>

    </footer>
  );
};

export default Footer;